module.exports = __webpack_public_path__ + "img/halloween_cupcake.bd38dffb.svg";